import React, { useState} from 'react';
import styled from 'styled-components';
import axios from 'axios';

const Permission = () => {
  const [notes, setNotes] = useState('');
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    axios.post('https://api.bakpoket.com/api/merchant/preferences/upsert',{notes})
    .then(res=>{console.log(res)
      alert('Permission Approved')
      setNotes("")
    })
    .catch(err => {console.log(err)
      alert('Permission failed.');
    })

   
  };

  
  return (
    <Wrapper>
      <Card>
        <h2>Give Permission for Scrape</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Notes"
            value={notes}
            required
            onChange={(e) => setNotes(e.target.value)}
          />
          <button type="submit">Submit</button>
        </form>
      </Card>
    </Wrapper>
  );
};

export default Permission;

// ✅ Wrapper styles
const Wrapper = styled.section`
  width: 100%;
  max-width: 1280px;
  margin: 2% auto;
  padding: 30px;
  border-radius: 15px;

  @media (max-width: 974px) {
    padding: 15px;
  }
`;

// ✅ Card styles
const Card = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  width: 100%;
  margin: auto;
  text-align: center;

  h2 {
    font-size: 22px;
    margin-bottom: 20px;
    color: #2a4157;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 10px;

    input[type='text'] {
      padding: 10px;
      border: 1px solid #ccc;
      border-radius: 6px;
    }

    button {
      padding: 10px 15px;
      background-color: #ef4766;
      border: none;
      color: white;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 600;
      transition: background 0.3s;

      &:hover {
        background-color: #d63c5b;
      }
    }
  }

  @media (max-width: 768px) {
    max-width: 220px;
    width: 85%;
    padding: 15px;

    h2 {
      font-size: 16px;
    }

    button {
      font-size: 12px;
      padding: 8px 12px;
    }

    input[type='text'] {
      padding: 6px;
      font-size: 11px;
    }
  }
`;
